import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

interface ServiceOperatorProtectedRouteProps {
  children: React.ReactNode;
}

export const ServiceOperatorProtectedRoute: React.FC<ServiceOperatorProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, user, checkAuth } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (isAuthenticated && user?.role !== 'service_operator') {
      // 非service_operatorは/bottlesにリダイレクト
      navigate('/bottles', { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'service_operator') {
    return null; // リダイレクト中
  }

  return <>{children}</>;
};
